(function () {
  'use strict';
  function exactWords(query) {
    var value = String(query || '').trim();
    if (!value || /[":()*\\]|(?:^|\s)(?:AND|OR|NOT)(?:\s|$)/.test(value)) return value;
    return value.split(/\s+/).join(' ');
  }
  var config = document.querySelector('[data-msd-search-query]');
  if (!config) return;
  var searchPath = config.getAttribute('data-search-path');
  function normalize(url) {
    if (url.origin !== window.location.origin || url.pathname !== searchPath) return url;
    var query = url.searchParams.get('q');
    if (query) url.searchParams.set('q', exactWords(query));
    return url;
  }
  var current = new URL(window.location.href);
  var next = normalize(new URL(current.href));
  if (next.href !== current.href) {
    window.location.replace(next.href);
    return;
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var destination = new URL(form.action, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname !== searchPath || form.method.toLowerCase() !== 'get') return;
    var fields = new FormData(form);
    if (!fields.has('q')) return;
    fields.forEach(function (value, key) {
      if (typeof value === 'string') destination.searchParams.set(key, value);
    });
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(normalize(destination).href);
  }, true);
}());
